import { combineReducers } from "redux";

import data from "./data";
import fetching from "./fetching";
import update from "./update";
import updating from "./updating";
import searching from "./searching";
import search from "./search";
import verifying from "./verifying";
import verify from "./verify";
import returnLabelFetching from "./returnLabelFetching";

export default combineReducers({ data, fetching, update, updating, searching, search, verifying, verify, returnLabelFetching });
